/**
 * Centralna konfiguracja projektu "Zapracuj na przyszłość"
 * 
 * Zawiera wszystkie stałe używane w projekcie:
 * - Linki do social media
 * - Dane kontaktowe
 * - Informacje o projekcie
 * - URL-e strony
 */

export const SOCIAL_LINKS = {
  tiktok: 'https://www.tiktok.com/@create_the_future_',
  instagram: 'https://www.instagram.com/create.the.future_',
  email: 'zapracujnaprzyszlosc.zzt@gmail.com',
  github: 'https://github.com/philornot',
};

export const SITE_INFO = {
  name: 'Zapracuj na przyszłość',
  nameEN: 'Create the Future',
  domain: 'https://zapracujnaprzyszlosc.pl',
  logo: '/logo512.png',
  description: {
    pl: 'Projekt społeczny pomagający młodym ludziom w wyborze ścieżki kariery poprzez wywiady z profesjonalistami z różnych branż.',
    en: 'A social project helping young people choose their career path through interviews with professionals from various industries.',
  },
};

export const TIKTOK_VIDEOS = {
  weddingPlanner: 'https://www.tiktok.com/embed/v2/7455328205524831510',
  pilot: 'https://www.tiktok.com/embed/v2/7456826488516644118',
  salesDirector: 'https://www.tiktok.com/embed/v2/7440874750055828758',
  graphicDesigner: 'https://www.tiktok.com/embed/v2/7453490391128526102',
  furnitureSales: 'https://www.tiktok.com/embed/v2/7449853144714005793',
  aboutUs: 'https://www.tiktok.com/embed/v2/7437882349603310870',
  profileEmbed: 'https://www.tiktok.com/embed/@create_the_future_',
};

export const ANALYTICS = {
  googleAnalyticsId: 'G-DPRX336JZL',
  googleTagManagerId: 'GTM-TKT29P3M',
  hotjarId: 5357630,
};

export const YOUTUBE = {
  projectSummary: 'https://www.youtube.com/embed/QcLgLaB0hoc?si=dN2aTsxDuQM5GRud',
};

export const EXTERNAL_LINKS = {
  zwolnieniZTeorii: 'https://zwolnienizteorii.pl/',
};

export const ROUTES = {
  home: '/',
  about: '/o-nas',
  tiktok: '/tiktok',
  contact: '/kontakt',
};